import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * TemplateContext — memuat template tenant primary sekali.
 * Sumber: GET /api/templates/current (public).
 */
const TemplateContext = createContext({
  loading: true,
  error: null,
  template_key: null,
  template: null,
  metadata: {},
  refresh: async () => {},
});

export function TemplateProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    error: null,
    template_key: null,
    template: null,
    metadata: {},
  });

  const load = useCallback(async () => {
    try {
      const r = await api.get("/templates/current");
      const tpl = r.data.template || null;
      setState({
        loading: false,
        error: null,
        template_key: r.data.template_key || null,
        template: tpl,
        metadata: tpl?.metadata || {},
      });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e?.message || "Gagal memuat template" }));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <TemplateContext.Provider value={{ ...state, refresh: load }}>
      {children}
    </TemplateContext.Provider>
  );
}

/**
 * useTemplate() — return { template_key, template, metadata, loading, error, refresh }
 *
 * Contoh:
 *   const { metadata, loading } = useTemplate();
 *   if (metadata.hero_style === "video-menu") return <VideoHero />;
 */
export function useTemplate() {
  return useContext(TemplateContext);
}
